export const OPERATING_SYSTEMS = {
  ANDROID: "android",
  LINUX: "linux",
  MACOS: "darwin",
  WEBOS: "webos",
  WINDOWS: "win32",
} as const;

export const UPGRADE_OPERATING_SYSTEMS = [
  OPERATING_SYSTEMS.ANDROID,
  OPERATING_SYSTEMS.LINUX,
  OPERATING_SYSTEMS.WEBOS,
  OPERATING_SYSTEMS.WINDOWS,
];

export const INTEGRATION_TYPES = {
  AGENT: "agent",
  PLAYER: "player",
  THIRDPARTY: "thirdparty",
} as const;

export type IntegrationType =
  (typeof INTEGRATION_TYPES)[keyof typeof INTEGRATION_TYPES];
